module.exports = __webpack_public_path__ + "static/media/notprocessing.7103263f.svg";